<template>
	<div class="contents-body myp" :class="{'hr_evl' : isPmg || isSco}">
		<div class="profile_box">
			<div class="image_box">
				<ImageComp v-if="info.gender == 'M'" :src="imgSrc" defaultSrc="PROFILE"/>
				<ImageComp v-if="info.gender == 'F'" :src="imgSrc" defaultSrc="PROFILE_W"/>
			</div>
			<template v-if="isPmg">
				<div class="name">
					<span class="age">경력 {{info.totWorkMonthCnt | months}}</span>
				</div>
				<div class="human_int" @click="setInterestYn()"><img :src="info.interestYn == 'Y' ? '/images/tec/prj/heart_01.png' : '/images/tec/prj/heart_00.png'" alt="관심인재"/>관심인재</div>
				<div class="project" v-if="info.projectNowTerm" @click="showProjectRecrRate()">
					<img src="/images/prj_icon.png" alt="프로젝트 참여중"/>프로젝트 참여중
				</div>
				<div class="interview" @click="reqInteview()">
					인터뷰 요청
				</div>
			</template>
			<template v-else-if="isSco">
				<div class="name">
					<span class="age">경력<nbsp n="1"/>
						<span v-if="info.totWorkMonthCnt">{{info.totWorkMonthCnt | months}}</span>
						<span v-else>0개월</span>
					</span>
				</div>
				<div class="project" v-if="info.projectNowTerm" @click="showProjectRecrRate()">
					<img src="/images/prj_icon.png" alt="프로젝트 참여중"/>프로젝트 참여중
				</div>
			</template>
			<template v-else>
				<div class="name">{{info.mberNm}}
					<span class="age">경력<nbsp n="1"/>
						<span v-if="info.totWorkMonthCnt">{{info.totWorkMonthCnt | months}}</span>
						<span v-else>0개월</span>
					</span>
				</div>
				
				<div v-if="isMy && info.specialGradeYn == 'Y'" class="special">
					<div>
						<img src="/images/tec/myp/special_grade.png" />
					</div>
				</div>
				
				<div class="pro-point" @click="click('POINT')">						
					<div class="amount">{{info.pointSum | number}}</div>
					<span>적립포인트</span>
				</div>
				<div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
					<div class="inform btn_cursor" @click="click('EDITINFO')" v-if="isMy">정보수정하기</div>
					<div class="inform btn_cursor finalTec" @click="admModify()" v-if="isAdmin && finalTec == 'Y'">정보수정하기</div>
					<div class="inform btn_cursor" @click="click('PRINT')">
						<p>이력서 출력</p>
					</div>
					<!-- <div class="inform btn_cursor" @click="printTecCert()" v-if="isMy">기술등급 증명서</div> -->
				</div>
			</template>
		</div>

		<top-info :value="info" class="member-box" v-if="isPmg || isSco"/>
		
		<div class="mypage_pf">
			<!--클라이언트-->
			<div class="mystate mt-5" v-if="isPmg || isSco">
				<div class="noti" style="width: 420px; gap: 0; justify-content: space-evenly; padding-left: 0;">
					<div class="btn_cursor" @click="popupProject">						
						<div>
							<span class="mystate_cnt">{{info.projectEndCnt}}</span>
							<span class="mystate_tit">프로젝트 평가</span>
						</div>
					</div>
					<div class="tot_eval">
						<div>
							<grade-img type="CLIENT_EVAL_SM" :class="info.totEvalGradeCd? 'rank' : 'rank py-3'" :grade="info.totEvalGradeCd"/>
							<SelectComp tagName="p" class="tot_lev" type="text" :value="info.totEvalGradeCd" v-if="info.totEvalGradeCd" cdId="PRO126"/>
							<span class="mystate_tit">종합 평가 등급</span>
						</div>
					</div>		
				</div>
				<div v-if="info.specialGradeYn == 'Y'" class="special">
					<div>
						<img src="/images/tec/myp/special_grade.png" />
						<span>스페셜리스트</span>
						<span>그레이프 프로 인증</span>
					</div>
				</div>
			</div>
			<!--클라이언트-->

			<!--개인 / admin-->
			<div class="mystate" v-else>
				<div class="noti">
					<div class="btn_cursor" @click="click('INTERVIEW')">
						<div v-if="info.interviewCount.charAt(0) == 'Y'"><img src="/images/tec/myp/icon_new.png" alt="new"></div>
						<div>
							<span class="mystate_cnt">{{info.interviewCount.substr(1) }}</span>
							<span class="mystate_tit">인터뷰 요청</span>
						</div>
					</div>
					<div class="btn_cursor" @click="click('RESMVIEW')">
						<div v-if="info.resumeViewCount.charAt(0) == 'Y'"><img src="/images/tec/myp/icon_new.png" alt="new"></div>
						<div>
							<span class="mystate_cnt">{{info.resumeViewCount.substr(1)}}</span>
							<span class="mystate_tit">이력서 열람</span>
						</div>
					</div>
					<div class="btn_cursor" @click="click('INTREST')">
						<div v-if="info.interestCount.charAt(0) == 'Y'"><img src="/images/tec/myp/icon_new.png" alt="new"></div>
						<div>
							<span class="mystate_cnt">{{info.interestCount.substr(1)}}</span>
							<span class="mystate_tit">관심인재 등록</span>
						</div>
					</div>					
				</div>
				
				<div  class="state">
					<div>프로젝트 참여 가능</div>
					<div class="dev_state">
						{{possDate | date('yyyy. MM. dd 부터')}}
					</div>
					<div v-if="isMy" class="set-btn btn_cursor" @click="changeDevState()">설정 &#9654;</div>
				</div>
			</div>

			<!--개인 / admin-->
			<div class="myp_box top">
				<div class="ct" v-if="!isPmg">
					<div class="tit-box">회원 정보</div>
					<div class="profile"><div class="label myp">아이디    </div><div class="value">{{info.loginId}}</div></div>
					<div class="profile"><div class="label myp">휴대폰    </div><div class="value">{{info.hpNo | phone}}</div></div>
					<div class="profile"><div class="label myp">이메일    </div><div class="value">{{info.email}}</div></div>
					<div class="profile"><div class="label myp">생년월일  </div><div class="value">{{info.birthYyyymmdd | date('yyyy년 MM월 dd일')}}</div></div>
					<div class="profile"><div class="label myp">성별  </div><div class="value">{{info.gender | gender}}</div></div>
				</div>
				<div v-if="!isPmg" :class="isMY ? 'ct ncs' : 'ct'" >
					<div class="tit-box">
						소속 정보
						<span v-if="isMy" @click="click('ASGMNG')">소속사 관리 &#9654;</span>
					</div>
					<div class="mberAsg">
						<span v-if="(info.empDivCd == null || info.empDivCd == '') && (info.mberAsgInfo.mberAsgHistorySeq == null || info.mberAsgInfo.mberAsgHistorySeq == '')">
							
							<div class="profile"><div class="label myp">소속사</div><div class="value">-</div></div>
							<div class="profile"><div class="label myp">직원구분</div><div class="value">-</div></div>
							<div class="profile"><div class="label myp">상태</div><div class="value">-</div></div>
						</span>
						<span v-else>
							<div class="profile">
								<div class="label myp">소속사</div>
								<div class="value">
									<span v-if=" info.mberAsgInfo.asgApprStatus == '01'">소속없음</span>
									<span v-else-if=" info.mberAsgInfo.asgApprStatus == '02'">{{ info.mberAsgInfo.aftAsgNm }}</span>
									<span v-else >{{ info.mberAsgInfo.corpNm || '소속사 없음'}}</span>
								</div>
							</div>

							<div class="profile">
								<div class="label myp">직원구분</div>
								<div class="value"><SelectComp v-model="info.aftEmpDivCd" type="text" cdId="PRO102"/>
									<span v-if=" info.mberAsgInfo.asgApprStatus == '01'">프리랜서</span>
									<span v-else-if=" info.mberAsgInfo.asgApprStatus == '02'"><SelectComp v-model="info.mberAsgInfo.aftEmpDivCd" type="text" cdId="PRO102"/></span>
									<span v-else ><SelectComp v-model="info.mberAsgInfo.empDivCd" type="text" cdId="PRO102"/></span>
								</div>
							</div>

							<div class="profile">
								<div class="label myp">승인여부</div>
								<div class="value">
									<span v-if=" info.mberAsgInfo.asgApprStatus == '02'">승인 처리중</span>
									<span v-else-if=" info.mberAsgInfo.asgApprStatus == '04'">퇴사 처리중</span>
									<span v-else>승인</span>
								</div>
							</div>
						</span>
					</div>				
				</div>
			</div>

			<!-- 2번째 라인 -->
			<div class="myp_box top" :class="{none: isPmg}">
				<div class="ct level">
					<div class="tit-box">등급 기준</div>
					<div style="display: flex; justify-content: space-around;">
						<div class="cstom">
							<grade-img class="ranking" type="SCHOOL_TECH_MY" :grade="info.resumeSchoolTechGradeCd"/>
						</div>					
						<div class="cstom">
							<grade-img class="ranking" type="LICENSE_TECH_MY" :grade="info.resumeLicenseTechGradeCd"/>
						</div>
					</div>
				</div>

				<div style="display: flex; flex-direction: column;" >
					<template v-if="isMy">
						<div class="ct ncs">
							<div class="tit-box">
								NCS 자가평가
								<span @click="click('NCS')">NCS 자가평가 하기 &#9654;</span>
							</div>

							<ncs class="cstom mb-4" :value="info" @clickItem="click('NCS', $event)">
								<template v-slot:title>
									NCS 자가평가(직무 / 등급)
									<div class="ncs_shortcut" @click="click('NCS')">NCS 자가평가 하기 &#9654;</div>
								</template>
							</ncs>
						</div>
						<div class="ct edu">
							<div class="tit-box" @click="click('PROJ_NOW')">
								현재 참여 프로젝트
								<span>&#9654;</span>
							</div>
							<div class="cstom prj">
								<!-- 수행중인 프로젝트가 없을 경우 -->
								<template v-if="info.projectNow == null || info.projectNow.length == 0">
									<div class="none">&lowbar; &lowbar; &lowbar; &lowbar;</div>
								</template>
								<template v-else>
									<div class='prj-tit-hover' @click="click('PROJ_NOW', info.projectNow[0])">
										<div class="prj_name">'{{info.projectNow[0].projectNm}}'</div>
										<div class="prj_date">{{info.projectNow[0].joinStartYyyymmdd | date('yyyy.MM.dd')}} ~ {{info.projectNow[0].joinEndYyyymmdd | date('yyyy.MM.dd')}}</div>
									</div>
								</template>
							</div>
						</div>
					</template>

					<template v-else-if="isAdmin">
						<div class="ct great">
							<div class="tit-box">
								종합 평가
							</div>						
							<div class="flex flex-row sp-tw my-2">							
								<div class="tot_eval">								
									<div>
										<grade-img type="CLIENT_EVAL_SM" class="rank" :grade="info.totEvalGradeCd"/>
										<SelectComp tagName="p" class="special-txt" type="text" :value="info.totEvalGradeCd" v-if="info.totEvalGradeCd" cdId="PRO126"/>
										<span>종합 평가 등급</span>
									</div>
								</div>	
								<div v-if="info.specialGradeYn == 'Y'" class="special">
									<div>
										<img src="/images/tec/myp/special_grade.png" />
										<span class="special-txt">스페셜리스트</span>
										<span>그레이프 프로 인증</span>
									</div>
								</div>
							</div>
						</div>

						<div class="flex sp-tw mb-6">
							<div class="ct rank">
								<div class="tit-box" @click="click('CLIENT_EVAL')">
									클라이언트 평가 <span>&#9654;</span>
								</div>
								<eval-div-grade class="cstom btn_cursor" :value="info.clientEval" type="CLIENT_EVAL_SM" itemClass="eval" @click="click('CLIENT_EVAL')">
									<template v-slot:empty>
										<div class="eval none">
											- 평가없음 -
										</div>
									</template>
								</eval-div-grade>
							</div>
							<div class="ct rank last">
								<div class="tit-box" @click="click('PRON_EVAL')">
									그레이트프로 평가 <span>&#9654;</span>
								</div>
								<eval-div-grade class="cstom btn_cursor" :value="info.pronEval" type="PRON_EVAL" itemClass="eval" @click="click('PRON_EVAL')">
									<template v-slot:empty>
										<div class="eval none">
											- 평가없음 -
										</div>
									</template>
								</eval-div-grade>
							</div>
						</div>
					</template>
					
					<div v-else-if="isPmg">						
						<div class="flex sp-tw mb-6">
							<div class="ct evl">
								<div class="tit-box">
									클라이언트 평가
								</div>
								<eval-div-grade class="cstom" :value="info.clientEval" type="CLIENT_EVAL_SM" itemClass="eval">
									<template v-slot:empty>
										<div class="eval none">
											- 평가없음 -
										</div>
									</template>
								</eval-div-grade>
							</div>

							<div class="ct evl">
								<div class="tit-box">
									그레이트프로 평가
								</div>
								<eval-div-grade class="cstom" :value="info.pronEval" type="PRON_EVAL" itemClass="eval">
									<template v-slot:empty>
										<div class="eval none">
											- 평가없음 -
										</div>
									</template>
								</eval-div-grade>
							</div>
						</div>
						<div class="ct ncs mb-5">
							<div class="tit-box">
								NCS 자가평가(직무 / 등급)
							</div>
							<ncs class="cstom" :value="info" @clickItem="click('NCS', $event)">
								<template v-slot:title>NCS 자가평가(직무 / 등급)<div class="ncs_shortcut none" @click="click('NCS')" >NCS 자가평가 하기 &#9654;</div></template>
							</ncs>
						</div>
					</div>

					<div v-else-if="isSco">
						<div class="sp-tw">
							<div class="ct level mb-6">
								<div class="tit-box">
									클라이언트 평가
								</div>
								<eval-div-grade class="cstom" :value="info.clientEval" type="CLIENT_EVAL_SM" itemClass="eval">
									<template v-slot:empty>
										<div class="eval none">
											- 평가없음 -
										</div>
									</template>
								</eval-div-grade>
							</div>
						</div>
						<div class="ct ncs mb-5">
							<div class="tit-box">
								NCS 자가평가(직무 / 등급)
							</div>
							<ncs class="cstom" :value="info" @clickItem="click('NCS', $event)">
								<template v-slot:title>NCS 자가평가(직무 / 등급)<div class="ncs_shortcut none" @click="click('NCS')" >NCS 자가평가 하기 &#9654;</div></template>
							</ncs>
						</div>
					</div>
				</div>							
			</div>				

			<div class="myp_box top" style="border-bottom: none;" v-if="!(isPmg || isSco)">
				<div v-if="isMy" class="ct edu">
					<div class="tit-box">종합 평가</div>
					<div class="cstom">
						<div class="eval first">
							<SelectComp v-if="info.totEvalGradeCd" tagName="p" type="text" :value="info.totEvalGradeCd"  cdId="PRO126"/>
							<p v-else>평가전</p>
							<grade-img type="CLIENT_EVAL_SM" class="rank" :grade="info.totEvalGradeCd"/>
						</div>
					</div>
				</div>			

				<div v-else class="ct edu">
					<div class="tit-box" @click="click('PROJ_NOW')">
						현재 참여 프로젝트
						<span>&#9654;</span>
					</div>
					<div class="cstom prj">
						<!-- 수행중인 프로젝트가 없을 경우 -->
						<template v-if="info.projectNow == null || info.projectNow.length == 0">
							<div class="none">&lowbar; &lowbar; &lowbar; &lowbar;</div>
						</template>
						<template v-else>
							<div class='prj-tit-hover' @click="click('PROJ_NOW', info.projectNow[0])">
								<div class="prj_name">'{{info.projectNow[0].projectNm}}'</div>
								<div class="prj_date">{{info.projectNow[0].joinStartYyyymmdd | date('yyyy.MM.dd')}} ~ {{info.projectNow[0].joinEndYyyymmdd | date('yyyy.MM.dd')}}</div>
							</div>
						</template>
					</div>
				</div>

				<div class="ct edu">
					<div class="tit-box" @click="click('PROJ_BEF')">
						참여 예정 프로젝트
						<img v-if="info.projectNext != null && info.projectNext.length > 0 && info.projectNext[0].newYn == 'Y'" src="/images/tec/myp/icon_new.png" alt="new">
						<span>&#9654;</span>
					</div>
					<div class="cstom prj">
						<!-- 수행중인 프로젝트가 없을 경우 -->
						<template v-if="info.projectNext == null || info.projectNext.length == 0">
							<div class="none">&lowbar; &lowbar; &lowbar; &lowbar;</div>
						</template>
						<template v-else>
							<div class='prj-tit-hover' @click="click('PROJ_BEF', info.projectNext[0])">
								<div class="prj_name">'{{info.projectNext[0].projectNm}}'</div>
								<div class="prj_date">{{info.projectNext[0].joinStartYyyymmdd | date('yyyy.MM.dd')}} ~ {{info.projectNext[0].joinEndYyyymmdd | date('yyyy.MM.dd')}}</div>
							</div>
						</template>
					</div>
				</div>

				<div class="ct ncs" v-if="isAdmin">
					<div class="tit-box">
						NCS 자가평가 <span @click="reqNCS()" v-if="!info.ncsGrade || info.ncsGrade.length == 0">평가요청 &#9654;</span>
					</div>
					<ncs class="cstom" :value="info" @clickItem="click('NCS', { indMberSeq: techMberSeq, techGradeVerSeq : info.techGradeVerSeq, detailClassCd:$event.detailClassCd })">
						<template v-slot:title>
							<p class="ncs">
								NCS 자가평가(직무 / 등급)
								<span @click="reqNCS()" v-if="!info.ncsGrade || info.ncsGrade.length == 0">평가요청 &#9654;</span>
							</p>
						</template>
					</ncs>
				</div>			
			</div>
		</div>

		<div class="bottom-box" v-if="isPmg">
			※ 종합 평가 등급: 클라이언트 평가와 그레이트프로 평가의 평균값으로 산정된 등급입니다.<br/>
			※ 클라이언트 평가: 최근 5개 프로젝트의 평가 점수를 평균한 값입니다.  <br/>
			※ 그레이트프로 평가: 전체 활동 기간에 대한 내부 평가 결과입니다. <br/>
			※ NCS 등급: 초급(L2~L4), 중급(L5~L6), 고급(L7), 특급(L7~L8)
		</div>		

		<slot name="bottom"></slot>
	</div>
</template>

<script>
import gradeImg from "@/components/highpro/GradeImg.vue";
import topInfo from "@/components/highpro/TecInfo/TecInfoTopInfo.vue";
import ncs from "@/components/highpro/TecInfo/TecInfoNCS.vue";
import evalDivGrade from "@/components/highpro/EvalDivGrade.vue";
export default {
	components: { gradeImg, evalDivGrade, ncs, topInfo },
	props: {
		value: Object,
		type : String,
		tecMberSeq: {},
		prjtStat: {},
		nameViewYn: {},
		finalTec : String,
	},
	data(){
		return {
			techMberSeq: '',
			imgSrc: '',
			prjtStats: this.prjtStat,
			nmViewYn: this.nameViewYn,
		}
	},
	watch: {
		tecMberSeq(){
			this.search(true);
		}
	},
	mounted(){
 		this.search();
	},
	methods: {
        search(check = false){
			if(!check  || this.tecMberSeq != this.techMberSeq){
				if(this.tecMberSeq){
					this.techMberSeq = this.tecMberSeq;
				} else if(this.$store.state.userInfo.mberDivCd == '11'){
					this.techMberSeq = this.$store.state.userInfo.mberSeq;
				} else {
					this.techMberSeq = '';
					this.$emit('input', {});
				}

				if(this.techMberSeq){
					if(this.isAdmin || this.isMy){
						this.imgSrc = '/api/mem/prf/profile?tecMberSeq='+this.techMberSeq;
					}

					var sendParam = {};
					sendParam.tecMberSeq = this.techMberSeq;

					if(this.prjtStats) sendParam.prjtStats = this.prjtStats;
					if(this.nmViewYn) sendParam.nmViewYn = this.nmViewYn;

					this.$.httpPost('/api/mem/prf/getTecMyPage', sendParam)
						.then(res => {
							// console.log(res.data);
							this.$emit('input', res.data);			
						});
				}
			}
        },
		printResume(){
			//console.log('TecInfo printResume');

			this.$.httpPost('/api/mem/myp/getResumeAddYn', {techMberSeq : this.techMberSeq})
				.then(res => {
					if(res.data.resAddYn == 'Y') {
						window.open("/REPORT?tecMberSeq=" + this.techMberSeq + "&fileName=MEM910R01","report","width=900,height=800, scrollbars=yes, resizable=yes");
					}else {
						alert('이력서 등록 전 입니다.');
						return false;
					}
				})
		},
		// 기술등급 증명서 출력
		printTecCert(){
			this.$.httpPost('/api/mem/myp/setPrintTechCerti', {tecMberSeq : this.techMberSeq})
				.then(res => {
					//console.log('printTecCert RESULT', res);
					var url = "/REPORT?fileName=MEM910R02"
							+ "&issYyyy=" + res.data.issYyyy
							+ "&issSeq=" + res.data.issSeq
							+ "&verifyVal=" + res.data.verifyVal;

					window.open(url,"report","width=900,height=800, scrollbars=yes, resizable=yes");
				}).catch(this.$.httpErrorCommon);
		},
		click(type, item){
			//console.log('TecInfo click', type, item);
			if(this.isAdmin && type.toUpperCase() != 'PRINT'){
				this.$emit('click', {type, item});
			} else {
				switch(type.toUpperCase()){
					case 'NCS'		: 
						if(!item) this.move(type, 'PRF102M02', {type:'add'});
						else if(item.evlYn != 'Y') this.move(type, 'PRF102M02', {detailClassCd:item.detailClassCd});
						else this.popup(type, '/dco/pmg/prf/PRF301P05', { indMberSeq: this.techMberSeq, techGradeVerSeq : this.info.techGradeVerSeq, detailClassCd: item.detailClassCd });
						break;
					case 'PROJ_NOW'	: 
					case 'PROJ_BEF'	: 
						if(item) this.popup(type, '/tec/prj/PRJ102P01', { projectSeq : item.projectSeq });
						else this.move(type, 'PRJ102M01')
						break;
					case 'INTERVIEW': this.move(type, 'PRJ103M01'); break;
					case 'INTREST'	: this.move(type, 'PRF103M02'); break;
					case 'EDITINFO'	: this.move(type, 'MYP102M01'); break;
					case 'POINT'	: this.move(type, 'PIT101M01'); break;
					case 'RESMVIEW'	: this.move(type, 'PRF103M01'); break;
					case 'ASGMNG'	: this.move(type, 'PRF104M01'); break;
					case 'PRINT'    : this.printResume(); break;
				}
			}
		},
		move(type, name, params){
			//console.log('TecInfo move', type, name, params);
			if(name != null){
				this.$emit('move', type.toUpperCase(), params);
				this.$router.push({name, params});
			} else {
				//console.log('TecInfo move', type);
			}
		},
		popup(type, path, params){
			if(path != null){
				this.$emit('popup', type.toUpperCase(), params);
				this.$.popup(path, params);
			} else {
				//console.log('TecInfo popup', type);
			}
		},

		changeDevState() {
			var param = {
				value : this.value
			}
			this.$.popup('/tec/myp/MYP101P01', param)			
		},

		
		/* 클라이언트 프로젝트관리자 */
		showProjectRecrRate(){
			//console.log(this.info.projectNowTerm)
			if(this.info.projectNowTerm && this.info.projectNowTerm.length > 0){
				var term = this.info.projectNowTerm[0]
				this.$.popup('/dco/pmg/prf/PRF301P04', { recrStartYyyymmdd: term.joinStartYyyymmdd, recrEndYyyymmdd : term.joinEndYyyymmdd });
			}
		},
		reqInteview(){
			this.$.popup('/dco/pmg/prf/PRF301P02', { tecMberSeq: this.tecMberSeq })
				.then(res => {
					if(res){
						//this.search(this.tecMberSeq);
						this.$emit('updated', 'INTERVIEW', res);
					}
				});
		},
		setInterestYn(){
			this.$.popup('/dco/pmg/prf/PRF301P01', { tecMberSeq: this.tecMberSeq, regYn: this.info.interestYn == 'Y' ? 'N' : 'Y' })
				.then(res => {
					if(res){
						this.search();
						this.$emit('updated', 'INTEREST', res);
					}
				});
		},
		popupProject(){
        	//console.log('TecProfileSub01', 'popupProject', this.data);
			this.$emit('popup', 'PROJECT');
			if(this.info.projectEndCnt == 0) {
				alert("수행 완료된 프로젝트가 없습니다.");
			} else {
				this.$.popup('/dco/pmg/prf/PRF301P06', { tecMberSeq: this.techMberSeq, prjtStats: this.prjtStats, nmViewYn: this.nmViewYn });
			}
		},

		/* 관리자 */
		reqNCS(){
			this.$.popup('/adm/mem/MEM912P02', { tecMberSeq: this.techMberSeq });

		},

		/* 관리자 수정 */
		admModify() {

			var params = {
				tecMberSeq : this.techMberSeq,
				// caller : {
				// 	name: this.$route.name,
				// 	params: this.input,
				// }
			}
			
			this.$router.push({name: 'MEM910M04', params });
		},
	},
	computed: {
		info(){
			if(this.value && Object.keys(this.value).length > 0){
				return this.value;
			} else {
				return {
					birthYyyymmdd: '',
					interestCount: '',
					interviewCount: '',
					resumeViewCount: '',
				};
			}
		},
		possDate() {
			return this.value.joinPossYyyymmdd ? this.value.joinPossYyyymmdd : '-'
		},
		isAdmin() { return this.$store.getters.isAdmin },
		isMy() { return this.$store.state.userInfo.mberSeq == this.techMberSeq },
		isPmg() { return this.$store.state.userInfo.mberDivCd == '22'; },
		isSco() { return this.$store.state.userInfo.mberDivCd == '31'; }
	}
}
</script>